module.exports = __webpack_public_path__ + "static/media/Filter.5f7b9dfb.svg";